import { Dialog, Spinner } from "tamagui";
import { jsx, jsxs } from "react/jsx-runtime";
const DataLoadingDialog = props => {
  const contents = props.children ? props.children : /* @__PURE__ */jsx(Spinner, {
    size: "large",
    color: "$green10"
  });
  return /* @__PURE__ */jsxs(Dialog, {
    ...props,
    children: [/* @__PURE__ */jsx(Dialog.Trigger, {}), /* @__PURE__ */jsxs(Dialog.Portal, {
      children: [/* @__PURE__ */jsx(Dialog.Overlay, {}), /* @__PURE__ */jsx(Dialog.Content, {
        children: contents
      })]
    })]
  });
};
export { DataLoadingDialog };
//# sourceMappingURL=DataLoadingDialog.mjs.map
